import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Form, Field, ErrorMessage } from 'formik'
import Context from '../context/Context'

const SwishForm = ({ errors, isSubmitting }) => {
  const context = useContext(Context)

  return (
    <Form>
      <div className="container">
        <div className="row justify-content-center no-gutters">
          <div className="col-4 col-sm-2 text-right mr-2">
            <span className="paragraph-bold-14">Mobilnummer: </span>
          </div>
          <div className="col-4 col-sm-2 text-left mr-4">
            <Field type="text" name="cellPhone" className="swishElement" maxLength="10" />
          </div>
        </div>
        <div className="row justify-content-center no-gutters">
          <div className="col-8 col-sm-4 text-center">
            <ErrorMessage name="cellPhone" render={msg => <div className="swishValidationError">{msg}</div>} />
            {errors && errors.msg
              ? <div className="swishValidationError">{errors.msg}</div>
              : <div className="swishValidationError"></div>
            }
          </div>
        </div>
        <div className="row justify-content-center no-gutters">
          <div className="col-4 col-sm-2 text-right mr-2">
            <span className="paragraph-bold-14">OCR: </span>
          </div>
          <div className="col-4 col-sm-2 text-left mr-4">
            <span className="paragraph-regular-14">{context.invoice.ocr}</span><br />
          </div>
        </div>
        <div className="row justify-content-center no-gutters">
          <div className="col-4 col-sm-2 text-right mr-2">
            <span className="paragraph-bold-14">Belopp: </span>
          </div>
          <div className="col-4 col-sm-2 text-left mr-4">
            <span className="paragraph-regular-14">{context.invoice.remaining_amount} kr</span><br />
          </div>
        </div>
        <div className="row mt-2 justify-content-center">
          <div className="col-12 text-center">
            <button type="submit"
              style={context.style.button}
              className="btn btn-primary custom-btn-payment"
              disabled={isSubmitting}>Betala</button>
          </div>
        </div>
      </div>
    </Form >
  )
}

SwishForm.propTypes = {
  errors: PropTypes.object,
  isSubmitting: PropTypes.bool
}

export default SwishForm
